import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { PORTAL_TUTORIAL_TOTAL_STEPS } from '../const/portal-tutorial-steps.const'
import type { PortalTutorialStore } from '../interfaces/portal-tutorial-store.interface'

export const usePortalTutorialStore = create<PortalTutorialStore>()(
  devtools(
    immer((set) => ({
      phase: 'idle',
      currentStepIndex: 0,

      openWelcome: () =>
        set((state) => {
          state.phase = 'welcome'
          state.currentStepIndex = 0
        }),

      startTour: () =>
        set((state) => {
          state.phase = 'active'
          state.currentStepIndex = 0
        }),

      nextStep: () =>
        set((state) => {
          if (state.currentStepIndex >= PORTAL_TUTORIAL_TOTAL_STEPS - 1) {
            state.phase = 'completed'
            return
          }

          state.currentStepIndex += 1
        }),

      previousStep: () =>
        set((state) => {
          if (state.currentStepIndex <= 0) return
          state.currentStepIndex -= 1
        }),

      dismiss: () =>
        set((state) => {
          state.phase = 'idle'
          state.currentStepIndex = 0
        }),

      complete: () =>
        set((state) => {
          state.phase = 'completed'
        }),

      reset: () =>
        set((state) => {
          state.phase = 'idle'
          state.currentStepIndex = 0
        }),
    })),
    {
      name: 'PortalTutorialStore',
      enabled: process.env.NODE_ENV === 'development',
    }
  )
)
